import {ModalWithNewForm} from '~/components'
import {DatePickerField, Input} from '@eitje/web_components'
import {useParams} from '@eitje/bridge'
import {Organisation} from '@eitje/api'
import {goBack} from '~/routing/actions'

export const EditOrganisation = () => {
	const {id} = useParams()
	const organisation = Organisation.useFind(id)

	return (
		<ModalWithNewForm
			name="edit_organisation"
			onSubmit={params => organisation.update(params)}
			afterSubmit={goBack}
			modalProps={{okButtonProps: {t: 'common.save'}}}
			width={348}
			initialValues={organisation}
		>
			<Input field="name" required />
			<DatePickerField field="first_billing_date" required />
		</ModalWithNewForm>
	)
}
